import { HttpClient } from "@angular/common/http";
import { map, catchError } from "rxjs";
import { httpOptionsDefault } from "../../_shared/constants";
import { WebApiService } from "../WebApiService";


export class PlansController {
  constructor(public _http: HttpClient, private _webApi: WebApiService) {
  }
  list(): Promise<any[]> {



    return this._http.get(this._webApi.GetApiAddress() + `/plans/list`, httpOptionsDefault)
      .pipe(
        map(result => {


          return result;
        }

        ),
        catchError(error => {

          return error;
        })
      )
      .toPromise().then((result: any) => {


        return result;
      });

  }
}
